import { render, staticRenderFns } from "./ProductEditDialog.vue?vue&type=template&id=f1a41d7c&scoped=true&"
import script from "./ProductEditDialog.vue?vue&type=script&lang=js&"
export * from "./ProductEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditDialog.vue?vue&type=style&index=0&id=f1a41d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a41d7c",
  null
  
)

export default component.exports